const { getElement } = window.BAO.Utils

export class SiteDrawer extends window.BAO.CustomElement({
  SuperClass: HTMLElement,
}) {
  constructor() {
    super()

    this.drawers = getElement('site-drawers')
    if (!this.drawers) {
      throw new Error(
        `${this.nodeName.toLowerCase()} needs a <site-drawers> element to work`,
      )
    }
    this.drawers.drawers.push(this)

    // this.inert = true
    this._isOpen = false
    this._headerEl = null
  }

  connectedCallback() {
    super.connectedCallback()
  }

  get key() {
    return this.getAttribute('key')
  }

  get elements() {
    return {
      trigger: getElement(`[data-drawers-trigger=${this.key}]`),
      close: getElement(`[data-module-drawers-close=${this.key}]`),
    }
  }

  get isOpen() {
    return this._isOpen
  }

  set isOpen(val) {
    this._isOpen = val

    this.classList.toggle(this.config.classes.activeDrawerClass, val)

    if (val) {
      this.show()
    } else {
      this.close()
    }
  }

  show() {
    this.setAttribute('open', '')
    this.setPosTop()
  }

  close() {
    this.removeAttribute('open')
  }

  setPosTop() {
    this._headerEl = this._headerEl ?? document.querySelector('.section-header')

    if (this._headerEl) {
      const headerRect = this._headerEl.getBoundingClientRect()
      this.style.setProperty('--Header_Height', `${headerRect.bottom}px`)
    }
  }

  get config() {
    return {
      classes: {
        activeDrawerClass: 'drw-Drawer-active',
      },
    }
  }
}

export class SiteDrawerDialog extends window.BAO.CustomElement({
  SuperClass: HTMLDialogElement,
}) {
  constructor() {
    super()

    this.drawers = getElement('site-drawers')
    if (!this.drawers) {
      throw new Error(
        `${this.nodeName.toLowerCase()} needs a <site-drawers> element to work`,
      )
    }
    this.drawers.drawers.push(this)

    this.inert = true
    this._isOpen = false
    this._headerEl = null
  }

  connectedCallback() {
    super.connectedCallback()
  }

  get key() {
    return this.getAttribute('key')
  }

  get elements() {
    return {
      trigger: getElement(`[data-drawers-trigger=${this.key}]`),
      close: getElement(`[data-module-drawers-close=${this.key}]`),
    }
  }

  get isOpen() {
    return this._isOpen
  }

  set isOpen(val) {
    this._isOpen = val

    this.classList.toggle(this.config.classes.activeDrawerClass, val)

    if (val) {
      if (!this.hasAttribute('open')) {
        this.inert = false
        this.showModal()
      }
    } else {
      if (this.hasAttribute('open')) {
        this.inert = true
        this.close()
      }
    }
  }

  setPosTop() {
    this._headerEl = this._headerEl ?? document.querySelector('.section-header')

    if (this._headerEl) {
      const headerRect = this._headerEl.getBoundingClientRect()
      this.style.setProperty('--Header_Height', `${headerRect.bottom}px`)
    }
  }

  get config() {
    return {
      classes: {
        activeDrawerClass: 'drw-Drawer-active',
      },
    }
  }
}

// Register without extending built-in element
customElements.define('site-drawer', SiteDrawer)
customElements.define('site-drawer-dialog', SiteDrawerDialog, { extends: 'dialog' })

